import React from 'react';
import Wrapper from './styles';
import classNames from 'classnames';
import Svg from '../../svg/Svg';
import UiBadge from '../../ui/badge/UiBadge';

interface Props {
    to: string;
    icon: string;
    label: string;
    isActive?: boolean;
    badge?: number;
}

export default function SportNavLinkV2({ to, icon, label, isActive, badge }: Props) {
    return (
        <Wrapper
            to={to}
            className={classNames({
                ['sport-nav-link-selected']: isActive,
            })}
        >
            <Svg icon={icon} size={1.125} />
            <span>{label}</span>
            {Boolean(badge) && <UiBadge badge={badge} />}
        </Wrapper>
    );
}
